// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7ragz","buttons":"styles_buttons__2wcjC"};